export const paymentsKeys = {
  all: ['payments'] as const,
  beneficiaryForm: (accountId: string) => [...paymentsKeys.all, 'beneficiaryForm', accountId] as const,
  beneficiariesGridHeaders: (accountId: string) =>
    [...paymentsKeys.all, 'beneficiariesGridHeaders', accountId] as const,
  beneficiaryDetails: (id: string, isExternal = false) =>
    [...paymentsKeys.all, 'beneficiaryDetails', id, isExternal] as const,
};
